import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
/* empty css                         */
const RequiredFieldsLabel = ({ className }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: classnames("required-fields", className) }, /* @__PURE__ */ React.createElement("span", { className: "required-fields__asterisk" }, "*"), /* @__PURE__ */ React.createElement("div", { className: "required-fields__label" }, getLabel("common.form.field.required")));
};
export {
  RequiredFieldsLabel as default
};
//# sourceMappingURL=RequiredFieldsLabel.js.map
